var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.trainer
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-15 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-70 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  [
                    _c("md-toolbar", { attrs: { "md-elevation": 1 } }, [
                      _c("span", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.trainer.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.trainer
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "md-layout md-gutter md-alignment-top-center"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      padding: "50px",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    _vm.trainer.image != "undefined"
                                      ? _c("img", {
                                          attrs: {
                                            "trainer.image": "",
                                            src:
                                              "/static/uploads/" +
                                              _vm.trainer.image
                                          },
                                          on: { error: _vm.imageLoadingError }
                                        })
                                      : _c("img", {
                                          attrs: {
                                            src:
                                              "`/static/uploads/no-avatar.jpg`"
                                          }
                                        })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100"
                              },
                              [
                                _c(
                                  "md-list",
                                  { staticClass: "md-double-line" },
                                  [
                                    _c("md-subheader", [
                                      _vm._v("Kompetenzzentrum")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("apartment")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.trainer.competence_center
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Adresse")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("home")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.trainer.street))
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("span", [
                                              _c("strong", [
                                                _vm._v(_vm._s(_vm.trainer.zip))
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.trainer.city))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Telefon")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("phone")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.trainer.phone_number)
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("E-Mail")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("email")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.trainer.email))
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("md-subheader", [_vm._v("Web")]),
                                    _vm._v(" "),
                                    _c(
                                      "md-list-item",
                                      [
                                        _c(
                                          "md-icon",
                                          { staticClass: "md-primary" },
                                          [_vm._v("web")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "md-list-item-text" },
                                          [
                                            _c("span", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.trainer.web
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.trainer.web)
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout md-gutter md-alignment-top-center",
                                    staticStyle: { padding: "30px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                      },
                                      [
                                        _c("h4", [_vm._v("Schwerpunkte")]),
                                        _vm._v(" "),
                                        _vm.trainer.main_emphases
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                _vm.trainer.main_emphases,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    { key: item.hash },
                                                    [
                                                      _c(
                                                        "md-chip",
                                                        {
                                                          staticClass:
                                                            "md-primary",
                                                          staticStyle: {
                                                            margin: "2px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.trainer.main_emphases
                                          ? _c("div", [
                                              _c("h5", [
                                                _vm._v(
                                                  "Keine Schwerpunkte angegeben"
                                                )
                                              ])
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                      },
                                      [
                                        _c("h4", [_vm._v("Branchen")]),
                                        _vm._v(" "),
                                        _vm.trainer.industry_sectors
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                _vm.trainer.industry_sectors,
                                                function(item) {
                                                  return _c(
                                                    "div",
                                                    { key: item.hash },
                                                    [
                                                      _c(
                                                        "md-chip",
                                                        {
                                                          staticClass:
                                                            "md-primary",
                                                          staticStyle: {
                                                            margin: "2px"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.trainer.industry_sectors
                                          ? _c("div", [
                                              _c("h5", [
                                                _vm._v(
                                                  "Keine Branchen angegeben"
                                                )
                                              ])
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-15 md-medium-size-15 md-small-size-10 md-xsmall-size-0"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1619723e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1619723e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/kitrainersearch/detail/KITrainerDetail.vue
// module id = null
// module chunks = 